import React from 'react';
import { NavLink } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import { BsFillFileLockFill } from "react-icons/bs";


import RoleAPI from '../../../api/RoleAPI';
import Util from '../../../util/Util';
import Const from '../../../util/Constants';
import withRouter from '../../../util/WithRouter';
import Display from '../../../util/Display';
import ApiUiController from '../../../controller/ApiUiController';
import { reactLocalStorage } from 'reactjs-localstorage';
import Constants from '../../../util/Constants';
import PropertyConst from '../../../util/PropertyConst';

class RoleList extends React.Component {

  constructor(props) {
    super(props);
    this.roles = [];
    this.state = { inApiCall: true };
    this.path = this.props.match.path;

    const UserPackage = reactLocalStorage.getObject(Constants.LoggedInUser).package;
    const FieldLevelSecurity = reactLocalStorage.get(PropertyConst.FieldLevelSecurity);
    this.showFieldLevelSecurity = UserPackage === Const.PackageEnterprise || FieldLevelSecurity === Const.TextTrue;
  }

  componentDidMount() { RoleAPI.list(this.onReceived, this.onFail); }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = roles => { this.roles = roles; this.setState({ inApiCall: false }); };

  confirmDelete = index => {
    Util.confirmAlert('Delete', `Are you sure you want to delete to`
      + ` ${this.roles[index].name}`, 'Delete', 'No', () => {
        this.setState({ ...this.state, inApiCall: true });
        RoleAPI.delete(this.roles[index].id, this.onDelete, this.onFail);
      });
  };

  onDelete = () => {
    Util.showNotification('Successful', 'Role Deleted successfully', 'success');
    RoleAPI.list(this.onReceived, this.onFail);
  };

  render() {
    let rolesUI = this.roles.map((role, _i) => (
      <tr key={`role_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{role.name}</td>
        <td>{Display.ModelLabelValue('user', role.created_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(role.created_date)}</td>
        <td>{Display.ModelLabelValue('user', role.updated_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(role.updated_date)}</td>
        <td>
          <NavLink to={`${this.path}/add-edit/${role.id}`} className="buttons update">
            <FaPencilAlt /> Update
          </NavLink>
          {role.status !== Const.AlwaysActive &&
            <>
              {this.showFieldLevelSecurity
                ? <NavLink to={`${this.path}/${role.id}/module`} className="buttons note">
                  <BsFillFileLockFill /> Field Level Security
                </NavLink>
                : null
              }
              <span onClick={() => this.confirmDelete(_i)} className="buttons delete">
                <FaTrash /> Delete
              </span>
            </>
          }
        </td>
      </tr>
    ));
    rolesUI = rolesUI ? rolesUI : <tr><td colSpan="7">No Records Found</td></tr>;
    return (
      <div className="sectionlist pt-3">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6 pb-3">
              <h3>Roles</h3>
            </div>
            <div className="col-md-6 text-right pb-3">
              <NavLink to={`${this.path}/add-edit/0`} className="buttons success">+ Add Role</NavLink>
            </div>

            <div className="col-md-12">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>No</th> <th>Name</th> <th>Created By</th> <th>Created Date</th>
                    <th>Updated By</th> <th>Updated Date</th> <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <ApiUiController inApiCall={this.props.inApiCall} >
                    {rolesUI}
                  </ApiUiController>
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(RoleList);
